<template>
  <section class="cards__container">
    <div
      class="head-card"
      v-b-tooltip.hover
      title="Total de associados cadastrados no sistema"
    >
      <div class="head-card__left">
        <p class="head-card__left__title">Cooperados</p>
        <p
          v-if="!loading"
          class="head-card__left__info"
        >
          {{ totalCooperados }}
        </p>
        <b-skeleton
          v-else
          width="60%"
        ></b-skeleton>
      </div>
      <div class="head-card__right">
        <i class="fas fa-id-card-alt fa-gradient"></i>
      </div>
    </div>
    <div
      class="head-card"
      v-b-tooltip.hover
      title="Total de associados que possuem pelo menos uma matrícula ativa. Cada associado é contado apenas uma vez, mesmo que possua múltiplas matrículas ativas."
    >
      <div class="head-card__left">
        <p class="head-card__left__title">Cooperados Ativos</p>
        <p
          v-if="!loading"
          class="head-card__left__info"
        >
          {{ totalCooperadosAtivos }}
        </p>
        <b-skeleton
          v-else
          width="60%"
        ></b-skeleton>
      </div>
      <div class="head-card__right"><i class="fas fa-user-tie"></i></div>
    </div>
    <div
      class="head-card"
      v-b-tooltip.hover
      title="Quantidade de contatos únicos que serão adicionados após aplicar os filtros selecionados e remover duplicados por telefone e e-mail"
    >
      <div class="head-card__left">
        <p class="head-card__left__title">Cooperados Atingidos</p>
        <p
          v-if="!loading"
          class="head-card__left__info"
        >
          {{ totalCooperadosAtingidos }}
        </p>
        <b-skeleton
          v-else
          width="60%"
        ></b-skeleton>
      </div>
      <div class="head-card__right"><i class="fas fa-exclamation"></i></div>
    </div>
  </section>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'

import ListaContatoRepository from '@/shared/http/repositories/configurations/listacontato.js'

export default {
  name: 'FilterKpi',
  mixins: [ActionsForm],
  data () {
    return {
      loading: true,
      totalCooperados: 0,
      totalCooperadosAtivos: 0,
      totalCooperadosAtingidos: 0
    }
  },
  methods: {
    onLoad () {
      this.loadKpi()
    },
    loadKpi () {
      ListaContatoRepository.GetKpi()
        .then((response) => {
          let content = response.data

          if (content) {
            this.totalCooperados = content.totalCooperados
            this.totalCooperadosAtivos = content.totalCooperadosAtivos
            this.loading = false
          }
        })
        .catch(this.onException)
    },
    loadCooperadosAtingidos (cooperadosAtingidos) {
      this.totalCooperadosAtingidos = cooperadosAtingidos
    },
    clearData () {
      this.totalCooperados = 0
      this.totalCooperadosAtivos = 0
      this.totalCooperadosAtingidos = 0
      this.loading = true
      this.loadKpi()
    }
  }
}
</script>

<style lang="scss" scoped>
.cards__container {
  display: flex;
  justify-content: flex-start;
  gap: 1.5rem;
  margin-top: 2rem;
  margin-bottom: 1.5rem;

  @media screen and (max-width: 768px) {
    overflow: scroll;
  }

  .head-card {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0.75rem 1rem;
    height: 5rem;
    width: 25%;

    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
    border-radius: 4px;

    @media screen and (max-width: 768px) {
      min-width: 12rem;
    }

    &__left {
      &__title {
        font-size: 0.75rem;
        line-height: 100%;
        text-transform: uppercase;
        color: #8898aa;
        margin-bottom: 0.5rem;
      }

      &__info {
        font-weight: 600;
        font-size: 1rem;
        line-height: 100%;
        text-transform: uppercase;
        color: #4f5358;
      }

      .money::before {
        content: 'R$ ';
      }
    }

    &:nth-child(1) .head-card__right {
      background: linear-gradient(90deg, #f53959 0%, #f55d39 100%);
    }

    &:nth-child(2) .head-card__right {
      background: linear-gradient(90deg, #fb6641 0%, #fbab40 100%);
    }

    &:nth-child(3) .head-card__right {
      background: linear-gradient(90deg, #2dce8b 0%, #2dceca 100%);
    }

    &:nth-child(4) .head-card__right {
      background: linear-gradient(180deg, #11c8ef 0%, #1275ef 100%);
    }

    &__right {
      width: 2rem;
      height: 2rem;
      aspect-ratio: 1;
      border-radius: 999px;

      display: flex;
      align-items: center;
      justify-content: center;

      i::before {
        font-size: 1rem;
        background: linear-gradient(
          180deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0) 137.5%
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/component/FilterKpi.vue